import { CornerTriangle as IconComponent } from '@adobe/react-spectrum-ui/dist/CornerTriangle.js';
import { UIIcon } from '@adobe/react-spectrum/private/icon/UIIcon';
import React from 'react';
export default function CornerTriangle(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}